import ServiceTemplate from '@/components/ServiceTemplate';

export default function TransferShares() {
  const data = {
    title: 'Share Transfer Services',
    subtitle: 'Professional stock transfer services for corporations.',
    overviewTitle: 'Understanding Share Transfers',
    overviewImage: 'https://images.unsplash.com/photo-1578674351410-8b28ab3c66b6',
    description: [
      'Transferring corporate shares requires proper documentation, board approval, and compliance with both corporate restrictions and securities laws. Improper transfers can create legal complications and tax issues.',
      'Our share transfer service handles all aspects of stock transfers including preparing transfer documents, updating corporate records, issuing new certificates, and ensuring legal compliance.',
      'We ensure your stock transfer is properly documented, compliant with bylaws and shareholder agreements, and maintains accurate corporate records.'
    ],
    benefits: [
      { title: 'Legal Compliance', description: 'Ensure transfer complies with all requirements.' },
      { title: 'Proper Documentation', description: 'Complete transfer documents and records.' },
      { title: 'Cap Table Updates', description: 'Maintain accurate capitalization table.' },
      { title: 'Securities Compliance', description: 'Navigate securities law restrictions.' },
      { title: 'Board Approval', description: 'Obtain necessary board approvals.' },
      { title: 'New Certificates', description: 'Issue new stock certificates to transferees.' }
    ],
    process: [
      { title: 'Transfer Planning & Documentation', description: 'Review requirements and prepare comprehensive transfer agreements and documents.' },
      { title: 'Execution & Verification', description: 'Coordinate proper execution, notarization, and verification of all transfer documents.' },
      { title: 'Recording & Compliance', description: 'File and record transfers with appropriate authorities and ensure ongoing compliance.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'What restrictions apply to stock transfers?', answer: 'Bylaws, shareholder agreements, and securities laws may restrict transfers. Right of first refusal and board approval are common restrictions.' },
      { question: 'Do I need board approval?', answer: 'Most corporate bylaws require board approval for stock transfers. We review your specific requirements.' },
      { question: 'What about securities law compliance?', answer: 'Transfers must comply with federal and state securities laws. Resale exemptions may be available depending on circumstances.' },
      { question: 'How do I value shares for transfer?', answer: 'Valuation depends on transfer terms - sales at fair market value, gifts, or other arrangements require appropriate documentation.' },
      { question: 'What happens to the old certificates?', answer: 'Old certificates should be surrendered and cancelled, with new certificates issued to reflect current ownership.' },
      { question: 'Are there tax implications?', answer: 'Yes, transfers may trigger capital gains tax for seller and gift tax for gifts. Consult tax advisor for specific situations.' },
      { question: 'Can I transfer part of my shares?', answer: 'Yes, shareholders can transfer any portion of their holdings subject to transfer restrictions and minimum share requirements.' },
      { question: 'What if there\'s a shareholder agreement?', answer: 'Shareholder agreements typically control transfer terms including rights of first refusal, drag-along, and tag-along rights.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
